// extracted by mini-css-extract-plugin
export default {"simpleAddressText":"AddressTypeahead_simpleAddressText__ix8Wz","simpleAddressButton":"AddressTypeahead_simpleAddressButton__05MLI"};